function AdminPage() {
  return <div>Admin TODO</div>
}

export default AdminPage
